import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import ReactTooltip from 'react-tooltip'
import './../../../../assets/css/react-table.css';


import {
    _addNotification, _addNotificationError, convertTwoDecimalPoint
} from "../../../../server/util";
import { currency_symbol } from '../../../../server/constants';
var _ = require('lodash');
class AccountHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }


    render() {
        const { accountHistoryData, mealSchoolId } = this.props;
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (



            <ReactTable columns={[
                {
                    Header: "Date",
                    accessor: "transactionDateTime",
                    width: 200
                },
                {
                    Header: "Transaction",
                    id: 'transaction',
                    accessor: row => {
                        return (<span>{
                            row.transactionType === 'Deposit' || row.transactionType === "InstantPayment" || row.transactionType === "Donation" ?
                                (row.isPosDeposit ? 'POS ' : '') + row.transactionType + ' - ' + (row.paymentType === 'CreditCard' ? 'CC' : row.paymentType) :
                                (row.purchaseItemType === 'TransferDR' ? 'Transfer Withdrawal' :
                                    row.purchaseItemType === '' ? row.paymentType : row.purchaseItemType)}
                        </span>)
                    }
                },
                {
                    Header: `Account (${currency_symbol(mealSchoolId)})`,
                    id: 'amount',
                    accessor: row => {
                        return (
                            <div style={{ textAlign: "right" }}>
                                {
                                    currency_symbol(mealSchoolId) + ' '
                                    + (row.transactionType === 'Deposit' || ((row.transactionType === 'ImportBalance' || row.transactionType === 'Adjustment' || row.transactionType === 'Refund') && row.paymentType) ? '+' : '-') + convertTwoDecimalPoint(row.transactionAmount)
                                }
                            </div>
                        );
                    }
                },
                {
                    Header: `Balance (${currency_symbol(mealSchoolId)})`,
                    id: "finalBalance",
                    accessor: row => {
                        return (
                            <div style={{ textAlign: "right" }}>
                                {currency_symbol(mealSchoolId) + ' ' + convertTwoDecimalPoint(row.finalBalance)}
                            </div>
                        );
                    }
                },
                {
                    Header: "Note",
                    id: "note",
                    style: { textAlign: 'center' },
                    minWidth: 75,
                    filterable: false,
                    Cell: row => {
                        return (
                            <Fragment>
                                <a data-tip data-for={'ah-' + row.index}>{row.original.note}</a>
                                <ReactTooltip id={'ah-' + row.index} aria-haspopup='true' type="dark" effect="float">
                                    <div>
                                        {row.original.note}
                                    </div>
                                </ReactTooltip>
                            </Fragment>
                        )
                    }
                }
            ]} data={accountHistoryData} defaultPageSize={10} {...checkboxProps} />
        )
    }
}
export default AccountHistory;


// WEBPACK FOOTER //
// ./src/components/Parent/Home/StudentAccount/AccountHistory.js